import React from 'react';

import { ApButtonSecondary, ApButtonOrange } from '@alixpartners/ui-components';
import { StyledModal } from './RevertDialog.styles';

export const RevertDialog = ({ onClose, onSubmit }) => {
	return (
		<StyledModal
			header="Revert to the latest applied taxonomy"
			footer={() => (
				<React.Fragment>
					<ApButtonSecondary onClick={onClose}>Cancel</ApButtonSecondary>
					<ApButtonOrange onClick={onSubmit}>Revert</ApButtonOrange>
				</React.Fragment>
			)}
			hasClosed={onClose}
			isDismissible
			isOpen
		>
			This option will revert the project taxonomy below to the version most
			recently applied to your data. All other changes will be lost.
		</StyledModal>
	);
};
